/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActionSource = "ANNOUNCEMENT" | "BUSINESS_SEARCH" | "CHECKOUT_API" | "CONTACT_SEARCH" | "ENTER_DETAILS" | "PAYMENT_LINK" | "SCAN_QR" | "%future added value";
export type AgentTransactionType = "BUSINESS" | "REBALANCE" | "USER" | "%future added value";
export type UserInterface = "AGENT_PORTAL" | "API" | "AUTOMATIC" | "BUSINESS_PORTAL" | "CUSTOMER_APP_IOS" | "DISTRIBUTOR_APP" | "FRONTAPP" | "INTEGRATIONS_RECONCILIATION_PORTAL" | "KIOSK_NFC" | "KIOSK_QR" | "MERCHANT_QR" | "SLACK_TOOL" | "SMARTPHONE_APP" | "USSD" | "%future added value";
export type AgentTransactionInput = {
    amount: string;
    walletId?: string | null | undefined;
    userReference?: string | null | undefined;
    type?: AgentTransactionType | null | undefined;
    userInterface?: UserInterface | null | undefined;
    coords?: CoordinatesInput | null | undefined;
};
export type CoordinatesInput = {
    lng: number;
    lat: number;
    provider?: string | null | undefined;
    accuracy?: number | null | undefined;
};
export type P2PTransferInput = {
    recipientMobile: string;
    recipientName?: string | null | undefined;
    sendAmount: string;
    receiveAmount: string;
    feeAmount?: string | null | undefined;
    fxRate?: string | null | undefined;
    walletId?: string | null | undefined;
    userInterface?: UserInterface | null | undefined;
    actionUrl?: string | null | undefined;
    actionSource?: ActionSource | null | undefined;
    coords?: CoordinatesInput | null | undefined;
    clientId?: string | null | undefined;
};
export type AgentTransactionDepositSendMutationVariables = {
    atx: AgentTransactionInput;
    userId: string;
    agentId: string;
    transfer: P2PTransferInput;
    canReadBalance: boolean;
    canReadHistory: boolean;
    includeCancelled: boolean;
};
export type AgentTransactionDepositSendMutationResponse = {
    readonly manualDeposit: {
        readonly agentTransaction: {
            readonly id: string;
            readonly agentUser: {
                readonly " $fragmentRefs": FragmentRefs<"AgentTab_agentUser">;
            } | null;
        };
    } | null;
    readonly send: {
        readonly transfer: {
            readonly id: string;
            readonly user: {
                readonly primaryWallet: {
                    readonly " $fragmentRefs": FragmentRefs<"History_wallet">;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type AgentTransactionDepositSendMutation = {
    readonly response: AgentTransactionDepositSendMutationResponse;
    readonly variables: AgentTransactionDepositSendMutationVariables;
};



/*
mutation AgentTransactionDepositSendMutation(
  $atx: AgentTransactionInput!
  $userId: ID!
  $agentId: ID!
  $transfer: P2PTransferInput!
  $canReadBalance: Boolean!
  $canReadHistory: Boolean!
  $includeCancelled: Boolean!
) {
  manualDeposit(agentTransaction: $atx, agentUserId: $userId, agentId: $agentId) {
    agentTransaction {
      id
      agentUser {
        ...AgentTab_agentUser_4ErKPv
      }
    }
  }
  send(transfer: $transfer) {
    transfer {
      id
      user {
        primaryWallet {
          ...History_wallet @include(if: $canReadHistory)
          id
        }
        id
      }
    }
  }
}

fragment AdjustmentEntry_tx on AdjustmentEntry {
  __typename
  description
  senderMobile
  recipientMobile
  ...HistoryEntry_entry
}

fragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  currency
  isDeposit
  amount
  customerName
  customerMobile
  maybeTerminatedCustomerMobile
  agentId
  agentName
  agentUfid
  agentUserName
  subagentId
  subagentName
  subagentUfid
  type
  isBusinessWalletAtx
  merchantUfid
  merchantId
  walletAgentUfid
  walletAgentId
  isCancelled
  composingEntries {
    __typename
    amount
    summary
    isPending
    isCancelled
    whenEntered
    ... on AgentTransactionEntry {
      agentTransactionId
      isDeposit
    }
    id
  }
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...AgentHistoryEntry_entry
}

fragment AgentHistoryEntryDelegate_entry on HistoryEntry {
  __isHistoryEntry: __typename
  __typename
  ...AgentHistoryEntry_entry
  ...AgentHistoryAtxEntry_tx
}

fragment AgentHistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment AgentHistorySummary_summary on AgentDailySummary {
  date
  whenDayEnded
  dailyAward
  numSignups
  absoluteTransactionVolume
  effectiveTransactionVolume
  totalCommission
}

fragment AgentHistory_agent_1bayFN on Agent {
  id
  history(last: 30, includePending: true, includeCancelled: $includeCancelled) {
    edges {
      dailySummaries {
        whenDayEnded
        date
        totalCommission
        ...AgentHistorySummary_summary
      }
      node {
        __typename
        id
        whenEntered
        isCancelled
        ... on AgentTransactionEntry {
          agentTransactionId
          composingEntries {
            __typename
            ... on AgentTransactionEntry {
              agentTransactionId
            }
            id
          }
        }
        ...AgentHistoryEntryDelegate_entry
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}

fragment AgentTab_agentUser_4ErKPv on AgentUser {
  isActive
  ...ReportAgentIssue_agentUser
  ...ReportUserComplaint_agentUser
  ...AgentTransaction_agentUser
  ...CreateAgentAssistant_agentUser
  agent {
    id
    ufid
    name
    city
    subcity
    region
    isActive
    isReported
    isCompliant
    whenTerminated
    currency
    commissionStructureName
    commissionUrl
    principal {
      id
    }
    agentOnAgentGamingWatchlist {
      isOnList
      whenUpdated
    }
    agentOnAgentGamingWhitelist {
      isOnList
      whenUpdated
    }
    openingHoursDisplay(format: LONG)
    agentType
    recoveryBalance
    limitBalMin
    overdraftOffer {
      status
      id
    }
    subAgents {
      id
      ufid
      name
      agentType
    }
    managedByAgent {
      id
      ufid
      name
    }
    rebalanceNetworkHeadAgent {
      id
      ufid
      name
    }
    floatWallet {
      partnerOrg
      photoEditUrl
      id
      balance @include(if: $canReadBalance)
      mobile
      name
    }
    coords {
      lng
      lat
    }
    activeRebalanceLimit {
      rebalanceLimit
      whenActiveFrom
      whenActiveTo
      note
      isCurrentlySuspended
      suspensions {
        whenSuspendedFrom
        whenSuspendedTo
      }
    }
    ...AgentHistory_agent_1bayFN @include(if: $canReadHistory)
    ...AgentUsersList_agent
    ...CreateAgentTask_agent
    ...RequestToExplainCommissionCuts_agent
  }
  user {
    id
    mobile
  }
}

fragment AgentTransaction_agentUser on AgentUser {
  user {
    id
  }
  agent {
    id
    name
    floatWallet {
      balance
      id
    }
  }
}

fragment AgentUsersList_agent on Agent {
  principal {
    id
  }
  agentUsers {
    isActive
    canLogin
    user {
      id
      contactMobile
      name
    }
    agentAppVersion {
      appType
      string
      isUpToDate
    }
  }
}

fragment BillPaymentEntry_tx on BillPaymentEntry {
  transferId
  senderMobile
  maybeTerminatedSenderMobile
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  billPayProblems {
    whenOpened
    billType
    status
    transactionId
  }
  amount
  billAccount
  billId
  billName
  isCancelled
  summary
  errorCode
  localizedErrMessage
  airtimeSms
  meterNumber
  ...HistoryEntry_entry
}

fragment BlockRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  recipientName
  recipientMobile
}

fragment ChangePayoutRecipient_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment ChangeRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  amount
  receiveAmount
  recipientMobile
  recipientName
}

fragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment CreateAgentAssistant_agentUser on AgentUser {
  agent {
    ufid
    id
  }
}

fragment CreateAgentTask_agent on Agent {
  id
  ufid
  name
  territoryLeads {
    id
    name
  }
}

fragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {
  id
  whenEntered
  sendAmount
  receiveAmount
  isCancelled
  merchantId
  merchantName
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
    userInterface
  }
}

fragment HistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment History_wallet on Wallet {
  mobile
  cell: mobile
  user {
    devices {
      deviceId
      activeBlock {
        blockReason
        id
      }
    }
    id
  }
  supportHistoryConnection {
    edges {
      cursor
      node {
        __typename
        id
        scamInvestigationFields {
          deviceId
          deviceModel
          userInterface
        }
        ... on TransferSentEntry {
          transferId
          isPending
          isCancelled
        }
        ... on TransferReceivedEntry {
          transferId
          isPending
          isCancelled
        }
        ... on AgentTransactionEntry {
          agentTransactionId
          isPending
          isCancelled
        }
        ... on BillPaymentEntry {
          transferId
          isPending
          isCancelled
        }
        ... on PayoutTransferEntry {
          tcid
          isPending
          isCancelled
          amount
        }
        ...PersonalHistoryEntry_entry
        ... on HistoryEntry {
          __isHistoryEntry: __typename
          whenEntered
          isPending
          isCancelled
        }
        ... on TransferReceivedReversalEntry {
          reversedTransferId: transferId
          isPending
          isCancelled
        }
        ... on TransferSentReversalEntry {
          reversedTransferId: transferId
          isPending
          isCancelled
        }
        ... on PurchaseEntry {
          transferId
          isPending
          isCancelled
        }
        ... on RemittanceTransferReversalEntry {
          opaqueId
          isPending
          isCancelled
        }
        ... on FailedMerchantTransferEntry {
          sendAmount
          receiveAmount
          isCancelled
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}

fragment LoginLogoutEvent_tx on LoginLogoutEvent {
  id
  event
  whenEntered
  correspondingLoginTime
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
  }
}

fragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {
  amount
  summary
  description
  transferId
  mobile
  baseReceiptFields {
    formatType
    label
    value
  }
  ...HistoryEntry_entry
}

fragment PayoutTransferEntry_tx on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  senderName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment PersonalHistoryEntry_entry on SupportHistoryEntry {
  __isSupportHistoryEntry: __typename
  __typename
  ...HistoryEntry_entry
  ...UserAtxEntry_tx
  ...BillPaymentEntry_tx
  ...UserLinkedAccountTransferB2WEntry_tx
  ...UserLinkedAccountTransferW2BEntry_tx
  ...PaymentCardTransferEntry_tx
  ...TransferReceivedEntry_tx
  ...TransferSentEntry_tx
  ...TransferSentReversalEntry_tx
  ...TransferReceivedReversalEntry_tx
  ...PayoutTransferEntry_tx
  ...PurchaseEntry_tx
  ...RemittanceTransferReceivedEntry_tx
  ...RemittanceTransferReversalEntry_tx
  ...AdjustmentEntry_tx
  ...LoginLogoutEvent_tx
  ...FailedMerchantTransferEntry_tx
  ...ReversalDisputeEntry_tx
}

fragment PurchaseEntry_tx on PurchaseEntry {
  senderMobile
  maybeTerminatedSenderMobile
  amount
  merchantId
  merchantName
  merchantCode
  merchantMobile
  promoUsed
  transferId
  isRefunded
  isRemote
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
  ...RefundPurchaseEntry_transfer
}

fragment RefundP2P_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  sendAmount
  receiveAmount
  senderName
  senderMobile
  recipientName
  maybeTerminatedRecipientMobile
}

fragment RefundPurchaseEntry_transfer on PurchaseEntry {
  id
  transferId
  amount
  merchantName
}

fragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {
  id
  opaqueId
  description
  amount
  isPending
  isCancelled
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...RemittanceTransferRefund_transfer
  ...ChangeRemittanceRecipient_transfer
}

fragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {
  id
  opaqueId
  description
  amount
  isPending
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
}

fragment ReportAgentIssue_agentUser on AgentUser {
  agent {
    ufid
    name
    trainingTopics {
      type
      displayName
    }
    possibleIssueTypes {
      type
      displayName
      displayGroupName
    }
    principal {
      id
    }
    agentUsers {
      isActive
      user {
        id
        contactMobile
        name
      }
    }
    id
  }
}

fragment ReportUserComplaint_agentUser on AgentUser {
  agent {
    ufid
    name
    possibleIssueTypes {
      type
      displayName
      displayGroupName
    }
    id
  }
}

fragment RequestToExplainCommissionCuts_agent on Agent {
  id
  ufid
}

fragment ReversalDisputeEntry_tx on ReversalDisputeEntry {
  __typename
  description
  isPending
  ledgerTransactionId
  originalTransferId
  ...HistoryEntry_entry
}

fragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment TransferReceivedEntry_tx on TransferReceivedEntry {
  transferId
  senderName
  senderMobile
  maybeTerminatedSenderMobile
  paymentBatchId
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
}

fragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  recipientMobile
  ...HistoryEntry_entry
}

fragment TransferSentEntry_tx on TransferSentEntry {
  transferId
  senderMobile
  recipientName
  recipientMobile
  maybeTerminatedRecipientMobile
  amount
  receiveAmount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
  ...BlockRecipient_transfer
  ...HistoryEntry_entry
}

fragment TransferSentReversalEntry_tx on TransferSentReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  ...HistoryEntry_entry
}

fragment UserAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  isDeposit
  agentName
  agentId
  agentUfid
  customerMobile
  customerName
  maybeTerminatedCustomerMobile
  amount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atx"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCancelled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transfer"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "agentTransaction",
    "variableName": "atx"
  },
  {
    "kind": "Variable",
    "name": "agentUserId",
    "variableName": "userId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "includeCancelled",
  "variableName": "includeCancelled"
},
v10 = [
  {
    "kind": "Variable",
    "name": "transfer",
    "variableName": "transfer"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ufid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOnList",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "whenUpdated",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v22 = [
  (v8/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v23 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "includePending",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "last",
    "value": 30
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeposit",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerMobile",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedCustomerMobile",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentName",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentUfid",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantId",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackMessageUrl",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "relatedTicket",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenResolved",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamReportTicket",
  "kind": "LinkedField",
  "name": "scamReports",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceModel",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceName",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterface",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentMobile",
  "storageKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        (v44/*: any*/),
        (v45/*: any*/),
        (v46/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/)
  ],
  "type": "TransferSentEntry",
  "abstractKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPreviousPage",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startCursor",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderMobile",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientName",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientMobile",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedRecipientMobile",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receiveAmount",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "relatedTicket",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v21/*: any*/),
    (v39/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reference",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendAmount",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        (v46/*: any*/),
        (v48/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/)
  ],
  "type": "AgentTransactionEntry",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedSenderMobile",
  "storageKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v16/*: any*/),
    (v28/*: any*/),
    (v65/*: any*/)
  ],
  "type": "HistoryEntry",
  "abstractKey": "__isHistoryEntry"
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorCode",
  "storageKey": null
},
v70 = [
  (v28/*: any*/),
  (v26/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "partnerName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "liaTransferId",
    "storageKey": null
  },
  (v69/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFreezingFunds",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ledgerTransactionId",
  "storageKey": null
},
v74 = {
  "alias": "reversedTransferId",
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantName",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opaqueId",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderCountry",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamInvestigationFields",
  "kind": "LinkedField",
  "name": "scamInvestigationFields",
  "plural": false,
  "selections": [
    (v46/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentTransactionDepositSendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ManualDeposit",
        "kind": "LinkedField",
        "name": "manualDeposit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTransaction",
            "kind": "LinkedField",
            "name": "agentTransaction",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentUser",
                "kind": "LinkedField",
                "name": "agentUser",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "canReadBalance",
                        "variableName": "canReadBalance"
                      },
                      {
                        "kind": "Variable",
                        "name": "canReadHistory",
                        "variableName": "canReadHistory"
                      },
                      (v9/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "AgentTab_agentUser"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Send",
        "kind": "LinkedField",
        "name": "send",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "P2PTransfer",
            "kind": "LinkedField",
            "name": "transfer",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "primaryWallet",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "canReadHistory",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "History_wallet"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentTransactionDepositSendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ManualDeposit",
        "kind": "LinkedField",
        "name": "manualDeposit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTransaction",
            "kind": "LinkedField",
            "name": "agentTransaction",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentUser",
                "kind": "LinkedField",
                "name": "agentUser",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentTrainingTopicEntry",
                        "kind": "LinkedField",
                        "name": "trainingTopics",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentIssueEntry",
                        "kind": "LinkedField",
                        "name": "possibleIssueTypes",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayGroupName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "principal",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentUser",
                        "kind": "LinkedField",
                        "name": "agentUsers",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contactMobile",
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canLogin",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AppVersion",
                            "kind": "LinkedField",
                            "name": "agentAppVersion",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "appType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "string",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUpToDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "floatWallet",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partnerOrg",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "photoEditUrl",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subcity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "region",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isReported",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCompliant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "whenTerminated",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commissionStructureName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commissionUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "agentOnAgentGamingWatchlist",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "agentOnAgentGamingWhitelist",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "format",
                            "value": "LONG"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "openingHoursDisplay",
                        "storageKey": "openingHoursDisplay(format:\"LONG\")"
                      },
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recoveryBalance",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "limitBalMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentOverdraftOffer",
                        "kind": "LinkedField",
                        "name": "overdraftOffer",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "subAgents",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "managedByAgent",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "rebalanceNetworkHeadAgent",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Coordinates",
                        "kind": "LinkedField",
                        "name": "coords",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lng",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lat",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentRebalanceLimit",
                        "kind": "LinkedField",
                        "name": "activeRebalanceLimit",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rebalanceLimit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenActiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenActiveTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "note",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCurrentlySuspended",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgentRebalanceLimitSuspension",
                            "kind": "LinkedField",
                            "name": "suspensions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "whenSuspendedFrom",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "whenSuspendedTo",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StaffMember",
                        "kind": "LinkedField",
                        "name": "territoryLeads",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "canReadHistory",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "AgentHistoryConnection",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgentHistoryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgentDailySummary",
                                    "kind": "LinkedField",
                                    "name": "dailySummaries",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "whenDayEnded",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "date",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "totalCommission",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dailyAward",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numSignups",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "absoluteTransactionVolume",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "effectiveTransactionVolume",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/),
                                      (v8/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHistoryEntry"
                                      },
                                      (v27/*: any*/),
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v30/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "composingEntries",
                                            "plural": true,
                                            "selections": [
                                              (v24/*: any*/),
                                              (v8/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v26/*: any*/),
                                              (v25/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v30/*: any*/),
                                                  (v31/*: any*/)
                                                ],
                                                "type": "AgentTransactionEntry",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v18/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentUserName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentUfid",
                                            "storageKey": null
                                          },
                                          (v14/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBusinessWalletAtx",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantUfid",
                                            "storageKey": null
                                          },
                                          (v38/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "walletAgentUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "walletAgentId",
                                            "storageKey": null
                                          },
                                          (v40/*: any*/),
                                          (v43/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v49/*: any*/),
                                              (v51/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "AgentTransactionEntry",
                                        "abstractKey": null
                                      },
                                      (v49/*: any*/),
                                      (v51/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v52/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "filters": [
                              "around",
                              "when",
                              "includePending",
                              "includeCancelled"
                            ],
                            "handle": "connection",
                            "key": "AgentHistory_history",
                            "kind": "LinkedHandle",
                            "name": "history"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Send",
        "kind": "LinkedField",
        "name": "send",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "P2PTransfer",
            "kind": "LinkedField",
            "name": "transfer",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "primaryWallet",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "condition": "canReadHistory",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "alias": "cell",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mobile",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserDevice",
                                "kind": "LinkedField",
                                "name": "devices",
                                "plural": true,
                                "selections": [
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ActiveBlock",
                                    "kind": "LinkedField",
                                    "name": "activeBlock",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "blockReason",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SupportHistoryConnection",
                            "kind": "LinkedField",
                            "name": "supportHistoryConnection",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportHistoryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v52/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ScamInvestigationFields",
                                        "kind": "LinkedField",
                                        "name": "scamInvestigationFields",
                                        "plural": false,
                                        "selections": [
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v47/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isSupportHistoryEntry"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v50/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v57/*: any*/),
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v60/*: any*/),
                                          (v27/*: any*/),
                                          (v61/*: any*/),
                                          (v62/*: any*/),
                                          (v43/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v63/*: any*/),
                                              (v64/*: any*/)
                                            ],
                                            "type": "MobileTransferEntry",
                                            "abstractKey": "__isMobileTransferEntry"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v25/*: any*/),
                                              (v16/*: any*/),
                                              (v28/*: any*/),
                                              (v65/*: any*/),
                                              (v66/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "TransferSentEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v50/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v64/*: any*/),
                                          (v57/*: any*/),
                                          (v67/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "paymentBatchId",
                                            "storageKey": null
                                          },
                                          (v59/*: any*/),
                                          (v61/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v25/*: any*/),
                                              (v27/*: any*/),
                                              (v16/*: any*/),
                                              (v28/*: any*/),
                                              (v65/*: any*/),
                                              (v66/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v27/*: any*/),
                                              (v58/*: any*/),
                                              (v63/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "type": "MobileTransferEntry",
                                            "abstractKey": "__isMobileTransferEntry"
                                          }
                                        ],
                                        "type": "TransferReceivedEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v30/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v31/*: any*/),
                                          (v36/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/),
                                          (v33/*: any*/),
                                          (v32/*: any*/),
                                          (v34/*: any*/),
                                          (v27/*: any*/),
                                          (v62/*: any*/),
                                          (v43/*: any*/),
                                          (v68/*: any*/)
                                        ],
                                        "type": "AgentTransactionEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v50/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v57/*: any*/),
                                          (v67/*: any*/),
                                          (v40/*: any*/),
                                          (v43/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BillPayProblemTicket",
                                            "kind": "LinkedField",
                                            "name": "billPayProblems",
                                            "plural": true,
                                            "selections": [
                                              (v41/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "billType",
                                                "storageKey": null
                                              },
                                              (v21/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "transactionId",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v27/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "billAccount",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "billId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "billName",
                                            "storageKey": null
                                          },
                                          (v28/*: any*/),
                                          (v69/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "localizedErrMessage",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "airtimeSms",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "meterNumber",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v25/*: any*/),
                                              (v16/*: any*/),
                                              (v65/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "BillPaymentEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "tcid",
                                            "storageKey": null
                                          },
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderOpaqueId",
                                            "storageKey": null
                                          },
                                          (v64/*: any*/),
                                          (v59/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isReversal",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "sender",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "maybeRecipientName",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "recipientName",
                                            "storageKey": null
                                          },
                                          (v68/*: any*/)
                                        ],
                                        "type": "PayoutTransferEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v25/*: any*/),
                                          (v27/*: any*/),
                                          (v16/*: any*/),
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v65/*: any*/)
                                        ],
                                        "type": "HistoryEntry",
                                        "abstractKey": "__isHistoryEntry"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v70/*: any*/),
                                        "type": "UserLinkedAccountTransferB2WEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v70/*: any*/),
                                        "type": "UserLinkedAccountTransferW2BEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v71/*: any*/),
                                          (v50/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ReceiptField",
                                            "kind": "LinkedField",
                                            "name": "baseReceiptFields",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "formatType",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "label",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PaymentCardTransferEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v50/*: any*/),
                                          (v71/*: any*/),
                                          (v29/*: any*/),
                                          (v72/*: any*/),
                                          (v73/*: any*/),
                                          (v57/*: any*/),
                                          (v63/*: any*/),
                                          (v74/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "TransferSentReversalEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v50/*: any*/),
                                          (v71/*: any*/),
                                          (v29/*: any*/),
                                          (v72/*: any*/),
                                          (v73/*: any*/),
                                          (v57/*: any*/),
                                          (v63/*: any*/),
                                          (v59/*: any*/),
                                          (v74/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "TransferReceivedReversalEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v57/*: any*/),
                                          (v67/*: any*/),
                                          (v27/*: any*/),
                                          (v38/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantCode",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "promoUsed",
                                            "storageKey": null
                                          },
                                          (v50/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRefunded",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRemote",
                                            "storageKey": null
                                          },
                                          (v62/*: any*/),
                                          (v43/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "PurchaseEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v76/*: any*/),
                                          (v71/*: any*/),
                                          (v27/*: any*/),
                                          (v29/*: any*/),
                                          (v26/*: any*/),
                                          (v64/*: any*/),
                                          (v57/*: any*/),
                                          (v77/*: any*/),
                                          (v59/*: any*/),
                                          (v61/*: any*/)
                                        ],
                                        "type": "RemittanceTransferReceivedEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v76/*: any*/),
                                          (v71/*: any*/),
                                          (v27/*: any*/),
                                          (v29/*: any*/),
                                          (v64/*: any*/),
                                          (v57/*: any*/),
                                          (v77/*: any*/),
                                          (v59/*: any*/),
                                          (v61/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "RemittanceTransferReversalEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v71/*: any*/),
                                          (v57/*: any*/),
                                          (v59/*: any*/)
                                        ],
                                        "type": "AdjustmentEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "event",
                                            "storageKey": null
                                          },
                                          (v25/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "correspondingLoginTime",
                                            "storageKey": null
                                          },
                                          (v78/*: any*/)
                                        ],
                                        "type": "LoginLogoutEvent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v25/*: any*/),
                                          (v63/*: any*/),
                                          (v61/*: any*/),
                                          (v26/*: any*/),
                                          (v38/*: any*/),
                                          (v75/*: any*/),
                                          (v78/*: any*/)
                                        ],
                                        "type": "FailedMerchantTransferEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v71/*: any*/),
                                          (v29/*: any*/),
                                          (v73/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "originalTransferId",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ReversalDisputeEntry",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/),
                                  (v53/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": [
                              "when",
                              "around",
                              "deviceId"
                            ],
                            "handle": "connection",
                            "key": "History_supportHistoryConnection",
                            "kind": "LinkedHandle",
                            "name": "supportHistoryConnection"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3db721b807047354a012bea6af8fe3ba",
    "id": null,
    "metadata": {},
    "name": "AgentTransactionDepositSendMutation",
    "operationKind": "mutation",
    "text": "mutation AgentTransactionDepositSendMutation(\n  $atx: AgentTransactionInput!\n  $userId: ID!\n  $agentId: ID!\n  $transfer: P2PTransferInput!\n  $canReadBalance: Boolean!\n  $canReadHistory: Boolean!\n  $includeCancelled: Boolean!\n) {\n  manualDeposit(agentTransaction: $atx, agentUserId: $userId, agentId: $agentId) {\n    agentTransaction {\n      id\n      agentUser {\n        ...AgentTab_agentUser_4ErKPv\n      }\n    }\n  }\n  send(transfer: $transfer) {\n    transfer {\n      id\n      user {\n        primaryWallet {\n          ...History_wallet @include(if: $canReadHistory)\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AdjustmentEntry_tx on AdjustmentEntry {\n  __typename\n  description\n  senderMobile\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  currency\n  isDeposit\n  amount\n  customerName\n  customerMobile\n  maybeTerminatedCustomerMobile\n  agentId\n  agentName\n  agentUfid\n  agentUserName\n  subagentId\n  subagentName\n  subagentUfid\n  type\n  isBusinessWalletAtx\n  merchantUfid\n  merchantId\n  walletAgentUfid\n  walletAgentId\n  isCancelled\n  composingEntries {\n    __typename\n    amount\n    summary\n    isPending\n    isCancelled\n    whenEntered\n    ... on AgentTransactionEntry {\n      agentTransactionId\n      isDeposit\n    }\n    id\n  }\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...AgentHistoryEntry_entry\n}\n\nfragment AgentHistoryEntryDelegate_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  __typename\n  ...AgentHistoryEntry_entry\n  ...AgentHistoryAtxEntry_tx\n}\n\nfragment AgentHistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment AgentHistorySummary_summary on AgentDailySummary {\n  date\n  whenDayEnded\n  dailyAward\n  numSignups\n  absoluteTransactionVolume\n  effectiveTransactionVolume\n  totalCommission\n}\n\nfragment AgentHistory_agent_1bayFN on Agent {\n  id\n  history(last: 30, includePending: true, includeCancelled: $includeCancelled) {\n    edges {\n      dailySummaries {\n        whenDayEnded\n        date\n        totalCommission\n        ...AgentHistorySummary_summary\n      }\n      node {\n        __typename\n        id\n        whenEntered\n        isCancelled\n        ... on AgentTransactionEntry {\n          agentTransactionId\n          composingEntries {\n            __typename\n            ... on AgentTransactionEntry {\n              agentTransactionId\n            }\n            id\n          }\n        }\n        ...AgentHistoryEntryDelegate_entry\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment AgentTab_agentUser_4ErKPv on AgentUser {\n  isActive\n  ...ReportAgentIssue_agentUser\n  ...ReportUserComplaint_agentUser\n  ...AgentTransaction_agentUser\n  ...CreateAgentAssistant_agentUser\n  agent {\n    id\n    ufid\n    name\n    city\n    subcity\n    region\n    isActive\n    isReported\n    isCompliant\n    whenTerminated\n    currency\n    commissionStructureName\n    commissionUrl\n    principal {\n      id\n    }\n    agentOnAgentGamingWatchlist {\n      isOnList\n      whenUpdated\n    }\n    agentOnAgentGamingWhitelist {\n      isOnList\n      whenUpdated\n    }\n    openingHoursDisplay(format: LONG)\n    agentType\n    recoveryBalance\n    limitBalMin\n    overdraftOffer {\n      status\n      id\n    }\n    subAgents {\n      id\n      ufid\n      name\n      agentType\n    }\n    managedByAgent {\n      id\n      ufid\n      name\n    }\n    rebalanceNetworkHeadAgent {\n      id\n      ufid\n      name\n    }\n    floatWallet {\n      partnerOrg\n      photoEditUrl\n      id\n      balance @include(if: $canReadBalance)\n      mobile\n      name\n    }\n    coords {\n      lng\n      lat\n    }\n    activeRebalanceLimit {\n      rebalanceLimit\n      whenActiveFrom\n      whenActiveTo\n      note\n      isCurrentlySuspended\n      suspensions {\n        whenSuspendedFrom\n        whenSuspendedTo\n      }\n    }\n    ...AgentHistory_agent_1bayFN @include(if: $canReadHistory)\n    ...AgentUsersList_agent\n    ...CreateAgentTask_agent\n    ...RequestToExplainCommissionCuts_agent\n  }\n  user {\n    id\n    mobile\n  }\n}\n\nfragment AgentTransaction_agentUser on AgentUser {\n  user {\n    id\n  }\n  agent {\n    id\n    name\n    floatWallet {\n      balance\n      id\n    }\n  }\n}\n\nfragment AgentUsersList_agent on Agent {\n  principal {\n    id\n  }\n  agentUsers {\n    isActive\n    canLogin\n    user {\n      id\n      contactMobile\n      name\n    }\n    agentAppVersion {\n      appType\n      string\n      isUpToDate\n    }\n  }\n}\n\nfragment BillPaymentEntry_tx on BillPaymentEntry {\n  transferId\n  senderMobile\n  maybeTerminatedSenderMobile\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  billPayProblems {\n    whenOpened\n    billType\n    status\n    transactionId\n  }\n  amount\n  billAccount\n  billId\n  billName\n  isCancelled\n  summary\n  errorCode\n  localizedErrMessage\n  airtimeSms\n  meterNumber\n  ...HistoryEntry_entry\n}\n\nfragment BlockRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  recipientName\n  recipientMobile\n}\n\nfragment ChangePayoutRecipient_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment ChangeRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  amount\n  receiveAmount\n  recipientMobile\n  recipientName\n}\n\nfragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment CreateAgentAssistant_agentUser on AgentUser {\n  agent {\n    ufid\n    id\n  }\n}\n\nfragment CreateAgentTask_agent on Agent {\n  id\n  ufid\n  name\n  territoryLeads {\n    id\n    name\n  }\n}\n\nfragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {\n  id\n  whenEntered\n  sendAmount\n  receiveAmount\n  isCancelled\n  merchantId\n  merchantName\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n    userInterface\n  }\n}\n\nfragment HistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment History_wallet on Wallet {\n  mobile\n  cell: mobile\n  user {\n    devices {\n      deviceId\n      activeBlock {\n        blockReason\n        id\n      }\n    }\n    id\n  }\n  supportHistoryConnection {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n        scamInvestigationFields {\n          deviceId\n          deviceModel\n          userInterface\n        }\n        ... on TransferSentEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on TransferReceivedEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on AgentTransactionEntry {\n          agentTransactionId\n          isPending\n          isCancelled\n        }\n        ... on BillPaymentEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on PayoutTransferEntry {\n          tcid\n          isPending\n          isCancelled\n          amount\n        }\n        ...PersonalHistoryEntry_entry\n        ... on HistoryEntry {\n          __isHistoryEntry: __typename\n          whenEntered\n          isPending\n          isCancelled\n        }\n        ... on TransferReceivedReversalEntry {\n          reversedTransferId: transferId\n          isPending\n          isCancelled\n        }\n        ... on TransferSentReversalEntry {\n          reversedTransferId: transferId\n          isPending\n          isCancelled\n        }\n        ... on PurchaseEntry {\n          transferId\n          isPending\n          isCancelled\n        }\n        ... on RemittanceTransferReversalEntry {\n          opaqueId\n          isPending\n          isCancelled\n        }\n        ... on FailedMerchantTransferEntry {\n          sendAmount\n          receiveAmount\n          isCancelled\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment LoginLogoutEvent_tx on LoginLogoutEvent {\n  id\n  event\n  whenEntered\n  correspondingLoginTime\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n  }\n}\n\nfragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {\n  amount\n  summary\n  description\n  transferId\n  mobile\n  baseReceiptFields {\n    formatType\n    label\n    value\n  }\n  ...HistoryEntry_entry\n}\n\nfragment PayoutTransferEntry_tx on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  senderName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment PersonalHistoryEntry_entry on SupportHistoryEntry {\n  __isSupportHistoryEntry: __typename\n  __typename\n  ...HistoryEntry_entry\n  ...UserAtxEntry_tx\n  ...BillPaymentEntry_tx\n  ...UserLinkedAccountTransferB2WEntry_tx\n  ...UserLinkedAccountTransferW2BEntry_tx\n  ...PaymentCardTransferEntry_tx\n  ...TransferReceivedEntry_tx\n  ...TransferSentEntry_tx\n  ...TransferSentReversalEntry_tx\n  ...TransferReceivedReversalEntry_tx\n  ...PayoutTransferEntry_tx\n  ...PurchaseEntry_tx\n  ...RemittanceTransferReceivedEntry_tx\n  ...RemittanceTransferReversalEntry_tx\n  ...AdjustmentEntry_tx\n  ...LoginLogoutEvent_tx\n  ...FailedMerchantTransferEntry_tx\n  ...ReversalDisputeEntry_tx\n}\n\nfragment PurchaseEntry_tx on PurchaseEntry {\n  senderMobile\n  maybeTerminatedSenderMobile\n  amount\n  merchantId\n  merchantName\n  merchantCode\n  merchantMobile\n  promoUsed\n  transferId\n  isRefunded\n  isRemote\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n  ...RefundPurchaseEntry_transfer\n}\n\nfragment RefundP2P_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  sendAmount\n  receiveAmount\n  senderName\n  senderMobile\n  recipientName\n  maybeTerminatedRecipientMobile\n}\n\nfragment RefundPurchaseEntry_transfer on PurchaseEntry {\n  id\n  transferId\n  amount\n  merchantName\n}\n\nfragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  isCancelled\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...RemittanceTransferRefund_transfer\n  ...ChangeRemittanceRecipient_transfer\n}\n\nfragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n}\n\nfragment ReportAgentIssue_agentUser on AgentUser {\n  agent {\n    ufid\n    name\n    trainingTopics {\n      type\n      displayName\n    }\n    possibleIssueTypes {\n      type\n      displayName\n      displayGroupName\n    }\n    principal {\n      id\n    }\n    agentUsers {\n      isActive\n      user {\n        id\n        contactMobile\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment ReportUserComplaint_agentUser on AgentUser {\n  agent {\n    ufid\n    name\n    possibleIssueTypes {\n      type\n      displayName\n      displayGroupName\n    }\n    id\n  }\n}\n\nfragment RequestToExplainCommissionCuts_agent on Agent {\n  id\n  ufid\n}\n\nfragment ReversalDisputeEntry_tx on ReversalDisputeEntry {\n  __typename\n  description\n  isPending\n  ledgerTransactionId\n  originalTransferId\n  ...HistoryEntry_entry\n}\n\nfragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment TransferReceivedEntry_tx on TransferReceivedEntry {\n  transferId\n  senderName\n  senderMobile\n  maybeTerminatedSenderMobile\n  paymentBatchId\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n}\n\nfragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentEntry_tx on TransferSentEntry {\n  transferId\n  senderMobile\n  recipientName\n  recipientMobile\n  maybeTerminatedRecipientMobile\n  amount\n  receiveAmount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n  ...BlockRecipient_transfer\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentReversalEntry_tx on TransferSentReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  ...HistoryEntry_entry\n}\n\nfragment UserAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  isDeposit\n  agentName\n  agentId\n  agentUfid\n  customerMobile\n  customerName\n  maybeTerminatedCustomerMobile\n  amount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n"
  }
};
})();
(node as any).hash = '5d4f28b956bb512fe2cd72cd22cd3645';
export default node;
